import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  listNepalDescription,
  updateNepalDescription,
} from "../redux/actions/aboutNepalAction";
import { NEPAL_DESCRIPTION_UPDATE_RESET } from "../redux/constants/aboutNepalConstant";

const EditNepalScreen = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listNepalDescriptionState = useSelector(
    (state) => state.listNepalDescription
  );
  const { descriptions } = listNepalDescriptionState;
  const nepalDescriptionEdit = useSelector(
    (state) => state.nepalDescriptionEdit
  );
  const { success } = nepalDescriptionEdit;
  const [description, setDescription] = useState("");
  const handleProductForm = (e) => {
    e.preventDefault();
    dispatch(updateNepalDescription(description, uuid));
  };

  const handleCkEditorChange = (e, editor) => {
    setDescription(editor.getData());
  };
  useEffect(() => {
    dispatch(listNepalDescription());
    if (success) {
      navigate("/about-nepal");
      dispatch({ type: NEPAL_DESCRIPTION_UPDATE_RESET });
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Edit Description of Nepal" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleProductForm}>
            <div className="col-12 mb-3">
              <CKEditor
                editor={ClassicEditor}
                class="form-control"
                placeholder="Description of Job"
                style={{ width: "100%" }}
                onChange={(e, editor) => {
                  handleCkEditorChange(e, editor);
                }}
                data={descriptions && descriptions.description}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Edit Description
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditNepalScreen;
